import React from "react";
import styles from "./statCard.module.css";

const StatCard = ({
  label,
  value,
  valueColor,
  badge,
  badgeVariant,
  subtext,
}) => {
  return (
    <div className={styles.card}>
      <span className={styles.label}>{label}</span>

      {badge ? (
        <span
          className={[
            styles.badge,
            badgeVariant === "failed" ? styles.badgeFailed : "",
          ].join(" ")}
        >
          <span
            className={[
              styles.badgeDot,
              badgeVariant === "failed" ? styles.badgeDotFailed : "",
            ].join(" ")}
          />
          {badge}
        </span>
      ) : (
        <span
          className={styles.value}
          style={valueColor ? { color: valueColor } : undefined}
        >
          {value}
        </span>
      )}

      {subtext && <span className={styles.subtext}>{subtext}</span>}
    </div>
  );
};

export default StatCard;